import { Eyebrow } from "../ui/Eyebrow";
import { H1, Highlight } from "../ui/Heading";
import { HexButton } from "../ui/HexButton";
import { LINKS } from "../data/links";
import { IntegrationMarquee } from "./IntegrationMarquee";
import { PixelWordmark } from "./PixelWordmark";

export function Hero() {
  return (
    <section
      id="top"
      className="relative overflow-hidden bg-bg grain-dark px-8 pt-28 pb-32 max-md:pt-16 max-md:pb-20"
    >
      <div className="mx-auto max-w-[1280px] text-center flex flex-col items-center">
        <Eyebrow>An AI Chief of Staff for everyone who closes in chat</Eyebrow>

        <div className="mt-12 max-md:mt-8 max-md:scale-75 max-md:origin-top">
          <PixelWordmark px={18} />
        </div>

        <H1 className="!mt-14 max-w-[1080px] !text-[clamp(44px,5.6vw,80px)] !leading-[1.04] max-md:!mt-10">
          Give every operator their own <Highlight>AI employee</Highlight>.
        </H1>

        <p className="mt-7 max-w-[680px] text-[19px] leading-relaxed text-td-2">
          The analyst, coordinator, and deal-room operator sitting inside your
          Telegram. Reads every chat, remembers every relationship, drafts every
          follow-up, briefs you before every call.{" "}
          <span className="text-td-1">One per person. Always on.</span>
        </p>

        <div className="mt-10 flex justify-center">
          <HexButton variant="primary" size="lg" href={LINKS.setup}>
            Book a setup call
          </HexButton>
        </div>

        <div className="mt-10 flex items-center justify-center gap-2 flex-wrap font-mono text-xs tracking-wider text-td-3">
          <span>ONE ASSISTANT PER PERSON</span>
          <span>·</span>
          <span>RUNS INSIDE TELEGRAM</span>
          <span>·</span>
          <span>YOUR DATA STAYS YOURS</span>
          <span>·</span>
          <span className="inline-flex items-center gap-1.5">
            <span className="size-1.5 rounded-full bg-good" />
            BYOK
          </span>
        </div>
      </div>

      <div className="mx-auto mt-16 max-w-[1280px]">
        <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-td-3 text-center mb-4">
          Plugs into your stack
        </div>
        <IntegrationMarquee />
      </div>
    </section>
  );
}
